// extracted by mini-css-extract-plugin
export default {"link":"account-settings_link__LomMK","text":"account-settings_text__cObtT"};